// extracted by mini-css-extract-plugin
export default {"container":"ButtonWithLabel_container__pJUY2","label":"ButtonWithLabel_label__hcTXY","icon":"ButtonWithLabel_icon__ZQtOc"};